import React, { useState } from "react";
import { Card, Button, Form } from "react-bootstrap";
import { FormHelperText, Switch, FormControlLabel } from "@material-ui/core";
import { InputPic } from "../../../../_metronic/_partials/components/utils/InputPic";
import { InputFile } from "../../../../_metronic/_partials/components/utils/InputFile";   
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { useFormik } from "formik";
import * as yup from "yup";
import { useSelector, shallowEqual } from "react-redux";

import * as apiMateriali from "../../../api/materiali";
import { icons } from "../../../config/config";

const validationSchema = yup.object({
  sku: yup
    .string("Inserire uno sku valido")
    .required("Inserire uno sku valido")
    .min(2, "Minimo tre caratteri")
    .max(50, "Massimo cinquanta caratteri"),
  name: yup
    .string("Inserire un nome valido")
    .required("Inserire un nome valido")
    .min(3, "Minimo tre caratteri")
    .max(50, "Massimo cinquanta caratteri"),
  description: yup
    .string("Inserire una descrizione valida")
    .notRequired()
    .min(3, "Minimo tre caratteri")
    .max(500, "Massimo cento caratteri"),
  division: yup
    .number("Selezionare un'azienda")
    .positive("Selezionare un'azienda")
    .required("Selezionare un'azienda"),
  cost: yup
    .number("Inserire un costo valido")
    .required("Inserire un costo valido")
    .positive("Inserire un costo valido"),
  generic: yup
    .boolean("Inserire un valore valido")
    .required("Inserire un valore valido"),
  lot: yup
    .number("Inserire una quantità valida")
    .required("Inserire un quantità valida")
    .integer("Inserire un valore intero")
    .positive("Inserire un valore positivo"),
});

const actionsMessages = {
  new: "Crea",
  edit: "Modifica",
  removeImage: "Rimuovi Immagine",
  reset: "Reset",
};

const formFields = {
  sku: {
    label: "SKU",
    placeholder: "SKU...",
  },
  name: {
    label: "Nome materiale",
    placeholder: "Nome...",
  },
  description: {
    label: "Descrizione materiale",
    placeholder: "Descrizione...",
    rows: 3,
  },
  division: {
    label: "Selezionare azienda",
    placeholder: "Azienda...",
  },
  cost: {
    label: "Costo materiale (€)",
    placeholder: "Costo...",
  },
  image: {
    label: "Immagine prodotto",
  },
  pdf: {
    label: "PDF materiale",
  },
  generic: {
    label: "Materiale generico",
    placeholder: "Materiale generico...",
    helperText: "Se abilitato, il materiale sarà visibile a tutti gli agenti, altrimenti dovrà essere assegnato ad un prodotto",
  },
  lot: {
    label: "Pz./Cartone",
    placeholder: "Pz./Cartone...",
  },
};

const Toolbar = ({
  submitCallback,
  resetImmagineCallback,
  resetPdfCallback,
  resetCallback,
  closeCallback,
  loading,
  alreadyExisting,
  ...props
}) => {
  return (
    <div {...props}>
      <Button disabled={loading} onClick={submitCallback} className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-light-primary">
          <SVG src={toAbsoluteUrl(icons.ok)} />
        </span>
        {alreadyExisting ? actionsMessages.edit : actionsMessages.new}
      </Button>
      {!resetImmagineCallback ? null : (
        <Button disabled={loading} onClick={resetImmagineCallback} variant="danger" className="my-1 ml-2 d-inline-flex align-items-center">
          <span className="svg-icon svg-icon-md svg-icon-light-primary">
            <SVG src={toAbsoluteUrl(icons.close)} />
          </span>
          {actionsMessages.removeImage}
        </Button>
      )}
      <Button disabled={loading} onClick={resetCallback} variant="secondary" className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl(icons.reset)} />
        </span>
        {actionsMessages.reset}
      </Button>
      <Button onClick={closeCallback} variant="secondary" className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl(icons.go_back)} />
        </span>
        Materiale pubblicitario
      </Button>
    </div>
  );
};

export const EditNewMateriale = (props) => {
  const [loading, setLoading] = useState(false);

  // User redux
  const user = useSelector((state) => state.auth.user, shallowEqual);

  let initialState = {
    id: false,
    sku: "",
    name: "",
    description: "",
    division: 0,
    cost: "",
    image: false,
    generic: false,
    pdf: false,
    lot: 50,
  };
  const alreadyExisting = props.materiale !== false;
  if (alreadyExisting) {
    Object.assign(initialState, props.materiale);
  }
  
  const [sku, setSku] = useState(initialState.sku);
  const [name, setName] = useState(initialState.name);
  const [description, setDescription] = useState(initialState.description);
  const [division, setDivision] = useState(initialState.division);
  const [cost, setCost] = useState(initialState.price);
  const [image, setImage] = useState(initialState.image);
  const [pdf, setPdf] = useState(initialState.pdf);
  const [generic, setGeneric] = useState(initialState.generic);
  const [lot, setLot] = useState(initialState.lot);

  const handleReset = () => {
    setSku(initialState.sku);
    setName(initialState.name);
    setImage(initialState.image);
    setPdf(initialState.pdf);
    setDescription(initialState.description);
    setDivision(initialState.division);
    setCost(initialState.price);
    setGeneric(initialState.generic);
    setLot(initialState.lot);
    formik.handleReset();
  };

  const formik = useFormik({
    initialValues: {
      sku: sku,
      name: name,
      description: description,
      division: division,
      cost: cost,
      generic: generic,
      pdf: pdf,
      lot: lot,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      let result = new FormData();
      result.append("id", alreadyExisting ? initialState.id : "");
      result.append("sku", values.sku);
      result.append("name", values.name);
      result.append("azienda", values.division);
      result.append("descrizione", values.description);
      result.append("price", parseFloat(values.cost));
      result.append("accessToken", user.authToken);
      result.append("generic", values.generic);
      result.append("lot", parseInt(values.lot));
      if (pdf !== false) result.append("pdf", pdf);
      if (image !== false) result.append("image", image);
      
      apiMateriali
        .add(result)
        .then(() => {
          
          setLoading(false);
          props.triggerServerUpdate();
          props.hideEditPage();
        })
        .catch((e) => {
          setSubmitting(false);
          setLoading(false);
          setStatus(e.message);
        });
    },
  });
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  return (
    <Card className="card-custom gutter-b">
      <Card.Header className="border-0 py-5 row">
        <Card.Title className="float-left col-auto">
          <h3 className="font-weight-bolder text-dark">
            {alreadyExisting
              ? actionsMessages.edit + " materiale pubblicitario"
              : actionsMessages.new + " materiale pubblicitario"}
          </h3>
        </Card.Title>
        <Toolbar
          submitCallback={formik.handleSubmit}
          resetImmagineCallback={!image ? null : () => setImage(false)}
          resetPdfCallback={!pdf ? null : () => setPdf(false)}
          resetCallback={handleReset}
          closeCallback={props.hideEditPage}
          loading={loading}
          alreadyExisting={alreadyExisting}
          className="float-right col-auto"
        />
      </Card.Header>
      <Card.Body className="pt-0">
        <Form className="row">
          {formik.status && (
            <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
              <div className="alert-text font-weight-bold">{formik.status}</div>
            </div>
          )}
          <Form.Group className="col-xl-7 col-lg-7 col-sm-12">
            <Form.Label className="col-12">{formFields.name.label}</Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder={formFields.name.placeholder}
              value={name}
              onChange={(e) => setName(e.target.value)}
              className={getInputClasses("name")}
              {...formik.getFieldProps("name")}
            />
            {formik.touched.name && formik.errors.name ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.name}</div>
              </div>
            ) : null}
          </Form.Group>
          <Form.Group className="col-xl-2 col-lg-2 col-sm-12">
            <Form.Label className="col-12">{formFields.sku.label}</Form.Label>
            <Form.Control
              type="text"
              name="sku"
              placeholder={formFields.sku.placeholder}
              value={sku}
              onChange={(e) => setName(e.target.value)}
              className={getInputClasses("sku")}
              {...formik.getFieldProps("sku")}
            />
            {formik.touched.sku && formik.errors.sku ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.sku}</div>
              </div>
            ) : null}
          </Form.Group>
          <Form.Group className="col-xl-3 col-lg-3 col-sm-12">
            <Form.Label className="col-12">{formFields.cost.label}</Form.Label>
            <Form.Control
              type="number"
              name="cost"
              placeholder={formFields.cost.placeholder}
              value={cost}
              onChange={(e) => setCost(e.target.value)}
              className={getInputClasses("cost")}
              {...formik.getFieldProps("cost")}
            />
            {formik.touched.cost && formik.errors.cost ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.cost}</div>
              </div>
            ) : null}
          </Form.Group>
          <Form.Group className="col-xl-3 col-lg-3 col-sm-12">
            <Form.Label className="col-12">{formFields.lot.label}</Form.Label>
            <Form.Control
              type="number"
              name="lot"
              placeholder={formFields.lot.placeholder}
              value={lot}
              onChange={(e) => setLot(e.target.value)}
              className={getInputClasses("lot")}
              {...formik.getFieldProps("lot")}
            />
            {formik.touched.lot && formik.errors.lot ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.lot}</div>
              </div>
            ) : null}
          </Form.Group>
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields.division.label}</Form.Label>
            <select
              value={division}
              onChange={(e) => (e !== null ? setDivision(e.target.value) : null)}
              name="division"
              className={`form-control ${getInputClasses("division")}`}
              {...formik.getFieldProps("division")}
            >
              <option value={0}>Seleziona azienda</option>
              <option value={1}>Roypet</option>
              <option value={2}>Roydermal</option>
              <option value={11}>Valderma</option>
            </select>
            {formik.touched.division && formik.errors.division ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.division}</div>
              </div>
            ) : null}
          </Form.Group>
           <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <FormControlLabel
              control={
                <Switch
                  name="generic"
                  checked={generic ? true : false}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setGeneric(checked);
                  }}
                />
              }
              label={generic ? "Abilitato per tutti" : "Disponibile su assegnazione"} 
            />
            <FormHelperText>{formFields.generic.helperText}</FormHelperText>
          </Form.Group>
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields.image.label}</Form.Label>
            <InputPic
              name="productPic"
              id="productPic"
              pic={typeof image == "string" ? { name: image.split("/").slice(-1) } : image}
              setPic={setImage}
            />
          </Form.Group>
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields.pdf.label}</Form.Label>
            <InputFile
              name="productPdf"
              id="productPdf"
              file={typeof pdf == "string" ? { name: pdf.split("/").slice(-1) } : pdf}
              setFile={setPdf}
            />
          </Form.Group>
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields.description.label}</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              placeholder={formFields.description.placeholder}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={formFields.description.rows}
              style={{ resize: "none" }}
              className={getInputClasses("description")}
              {...formik.getFieldProps("description")}
            />
            {formik.touched.description && formik.errors.description ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.description}</div>
              </div>
            ) : null}
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
};
